
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('ellipse',{attrs:{"cx":"3.12","cy":"25.188","rx":"20.467","ry":"20.713","fill":"#fff","transform":"translate(22.364 .553)"}}),_c('path',{attrs:{"d":"M0 0v50h50V0H0zm22.574 11.64h4.799c.284 0 .498.108.64.32.143.214.214.463.214.747v9.066h9.066c.284 0 .533.071.746.213.213.143.32.357.32.641v4.799c0 .284-.107.498-.32.64a1.312 1.312 0 01-.746.213h-9.066v9.014c0 .284-.071.533-.213.746-.143.213-.357.32-.641.32h-4.799c-.284 0-.498-.107-.64-.32a1.312 1.312 0 01-.213-.746v-9.014h-9.014c-.284 0-.533-.07-.746-.213-.213-.142-.32-.356-.32-.64v-4.799c0-.284.107-.498.32-.64.213-.143.462-.214.746-.214h9.014v-9.066c0-.284.07-.533.213-.746.142-.213.356-.32.64-.32z","fill":"#004b78","paint-order":"markers stroke fill"}})])
          )
        }
      }
    